import { FC } from 'react';
import { TimeInput } from '../../../../../components/form/TimeInput';
import { Checkbox } from '../../../../../components/shared/checkboxes/Checkbox';
import { EmployeeSchedule } from '../../../../../helpers/BuildWorkingPattern';

interface TeamMemberScheduleEditFormRowProps {
  schedule: EmployeeSchedule;
  showDayLabel: boolean;
  onCheck?: () => void;
  onStartChange: (newVal?: string) => void;
  onEndChange: (newVal?: string) => void;
  canAdd?: boolean;
  canDelete?: boolean;
  onAdd?: () => void;
  onDelete?: () => void;
  addButtonLabel: string;
  deleteButtonLabel: string;
}

// const AddAvailabilityButton: FC<{ onClick?: () => void; label: string }> = ({ onClick, label }) => (
//   <button
//     type="button"
//     title={label}
//     onClick={onClick}
//     className="p-2 w-max h-[fit-content] rounded-full bg-green-50 hover:bg-green-100 border border-green-200 text-green-700 font-medium focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 ring-offset-white dark:ring-offset-black"
//   >
//     <span className="sr-only">{label}</span>
//     <FiPlus className="w-6 h-6" />
//   </button>
// );

// const DeleteAvailabilityButton: FC<{ onClick?: () => void; label: string }> = ({ onClick, label }) => (
//   <button
//     type="button"
//     title={label}
//     onClick={onClick}
//     className="p-2 w-max h-[fit-content] rounded-full bg-red-50 hover:bg-red-100 border border-red-200 text-red-600 font-medium focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 ring-offset-white dark:ring-offset-black"
//   >
//     <span className="sr-only">{label}</span>
//     <FiMinus className="w-6 h-6" />
//   </button>
// );

export const TeamMemberScheduleEditFormRow: FC<TeamMemberScheduleEditFormRowProps> = ({
  schedule,
  showDayLabel,
  onCheck,
  onStartChange,
  onEndChange
}) => {
  // const actionButtons = (
  //   <>
  //     {canAdd ? <AddAvailabilityButton onClick={onAdd} label={addButtonLabel} /> : null}
  //     {canDelete ? <DeleteAvailabilityButton onClick={onDelete} label={deleteButtonLabel} /> : null}
  //   </>
  // );

  return (
    <>
      <div className="flex schedules-center gap-2 items-center">
        {showDayLabel ? (
          <>
            <Checkbox checked={schedule.available} onChange={onCheck || (() => undefined)} />
            <p>{schedule.day}</p>
          </>
        ) : (
          <div className="pl-7" />
        )}
      </div>
      <TimeInput
        name={`${schedule.day}-${schedule.slotNumber}-from`}
        onChange={onStartChange}
        value={schedule.available ? schedule.start : ''}
        disabled={!schedule.available}
      />
      <TimeInput
        name={`${schedule.day}-${schedule.slotNumber}-to`}
        onChange={onEndChange}
        value={schedule.available ? schedule.end : ''}
        disabled={!schedule.available}
      />
    </>
  );
};
